module.exports = __webpack_public_path__ + "static/media/AB_K17_8.a85c70ec.jpg";